export default __webpack_public_path__ + "static/media/panier_vide.f1c5107b.png";